<template>
  <div>
    <article class="con3">
      <div class="container">
        <p id="carrotCoreValue" class="title-text">CARROT의 핵심가치</p>
        <ul>
          <li>
            <img
              src="@/assets/img/newGlobal/introduce/sub/philosophy/con3/img.jpg"
              alt="spirit, goal, team"
            />
          </li>
          <li>
            <div>
              <p><span>1 Spirit!</span> 최고의 정신</p>
              <p>
                최고의 컨텐츠와 서비스를 통해 최고의 일터를 만들고<br />최고의
                삶을 만들어 나가는 것.
              </p>
            </div>
            <div>
              <p><span>1 Goal!</span> 우리의 존재 이유는 바로 고객!</p>
              <p>
                우리의 행동과 판단은 항상 북극성처럼 고객을 향하며,<br />우리의
                모든 가치는 바로 고객으로 부터 나온다는 것.
              </p>
            </div>
            <div>
              <p><span>1 Team!</span> 팀을 통해 성장한다.</p>
              <p>
                팀 웍은 타인에 대한 배려와 적극적인 참여를 전제로한다.<br />우리는
                팀 웍을 통해 개인으로서의 나를 벗어나 더 큰 나, 더 큰 우리를
                실현해 나간다는 것.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </article>
  </div>
</template>

<script>
import "@/assets/style/newGlobalReset.scss";

export default {};
</script>

<style lang="scss" scoped>
.con3 {
  padding: 40px 0;

  @media screen and (min-width: 1350px) {
    padding: 80px 0;
  }

  .title-text {
    font-size: 30px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 20px;
  }

  ul {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 60px;
    text-align: center;

    @media screen and (min-width: 1350px) {
      flex-direction: row;
      justify-content: center;
      text-align: left;
    }

    li {
      img {
        width: 100%;
      }

      &:last-child {
        div {
          &:not(:last-child) {
            margin-bottom: 50px;
          }

          > p {
            &:nth-of-type(1) {
              font-size: 18px;
              font-weight: bold;
              margin-bottom: 10px;

              span {
                color: #fe4818;
              }
            }
          }
        }
      }
    }
  }
}
</style>
